///jacques-andre-editeur\proshop-v2\frontend\src\screens\HomeScreen.jsx
import { useState, useEffect } from 'react';
import { Container } from 'react-bootstrap';
import { useParams, Link, useLocation } from 'react-router-dom';
import { useGetBooksQuery } from '../slices/booksApiSlice';
import { useGetAuthorsQuery } from '../slices/authorsApiSlice';
import { useGetBooksCollectionsQuery } from '../slices/booksCollectionsApiSlice';
import BookCard from '../components/BookCard';
import AuthorCard from '../components/AuthorCard';
import BooksCollectionCard from '../components/BooksCollectionCard';
import Loader from '../components/Loader';
import Message from '../components/Message';
import ALaUne from '../components/ALaUne';
import Meta from '../components/Meta';

const HomeScreen = () => {

  const params = useParams();
  const location = useLocation();
  const successMessage = location.state?.success;

  // Utilisation de useState pour gérer les valeurs des paramètres
  const [pageNumber, setPageNumber] = useState(params.pageNumber || 1);

  //const [nbHighlightBook, setNbHighlightBook] = useState(0);

  // Effect pour mettre à jour si params change
  useEffect(() => {
    setPageNumber(params.pageNumber || 1);
  }, [params]);

  const { data: nouveautes, isLoading, error } = useGetBooksQuery({
    pageNumber,
    parPage:6
  });

  const { data: auteurs } = useGetAuthorsQuery({
    pageNumber,
    parPage:4,
  });

  const { data: collections } = useGetBooksCollectionsQuery({
    pageNumber,
    parPage:16,
  });

  return (
    <div>
      <Meta />
          {successMessage && <Message variant="success">{successMessage}</Message>}
        <ALaUne
          nouveautes={nouveautes?.books || []}
        />
      {isLoading ? (
        <Loader />
      ) : error ? (
        <Message variant='danger'>
          {error?.nouveautes?.message || error.error}
        </Message>
      ) : (
        <Container>
          <div className="h1-container">
            <h1>Nouveautés</h1>
          </div>
            <div className="book-row">
              {nouveautes?.books?.slice(0).map((book) => (
                <div className='book-card' key={book._id}>
                  <BookCard book={book} />
                </div>
              ))}
            </div>
            <div className="tousNosLivres-container">
              <Link to="/Livres" className="tousNosLivres">Tous nos livres</Link>
            </div>
          <div className="h1-container">
            <h1>Les auteurs</h1>
          </div>
          <div className="author-row">
            {auteurs?.authors?.slice(0).map((author) => (
              <div className='author-card' key={author._id}>
                <AuthorCard author={author} />
              </div>
            ))}
          </div>
          <div className="tousNosLivres-container">
            <Link to="/auteurs" className="tousNosLivres">Tous les auteurs</Link>
          </div>
          
          <div className="h1-container">
            <h1>Parmi nos collections</h1>
          </div>
          <div className="booksCollectionRow">
            {collections?.booksCollections
            ?.filter((booksCollection) => booksCollection.name !== 'Hors collection')
            .slice()
            .sort(() => Math.random() - 0.5)
            .slice(0, 4)
            .map((booksCollection) => (
              <div className='booksCollection-card' key={booksCollection._id}>
                <BooksCollectionCard booksCollection={booksCollection} />
              </div>
            ))}
          </div>
          <div className="tousNosLivres-container">
            <Link to="/collections" className="tousNosLivres">Toutes les collections</Link>
          </div>
        </Container>
      )}
    </div>
  );
};

export default HomeScreen;
